export default __webpack_public_path__ + "static/media/hotelmasterchef.8073cf25.apk";